(function () {
  'use strict';
  var input = document.getElementById('s-fichiers');
  if (!input) return;
  input.removeAttribute('hidden');
  input.classList.add('scdm-champ-cache');
  input.setAttribute('accept', [
    '.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp', '.avif', '.heic', '.heif',
    '.pdf', '.ai', '.eps', '.svg', '.psd', '.tif', '.tiff', '.indd', '.cdr',
    '.dxf', '.dwg', '.dng', '.cr2', '.cr3', '.nef', '.arw', '.raf', '.orf',
    '.zip', '.rar', '.7z', 'image/*', 'application/pdf'
  ].join(','));
})();
